import { environment } from '@environments/environment';

import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import {
  ActiveInvestorsFetchRequest,
  ActiveInvestorsFetchResponse,
  ConstantsInvestorGetResponse,
} from './constants.types';

@Injectable({
  providedIn: 'root',
})
export class ConstantsService {
  private http = inject(HttpClient);

  fetchList(): Observable<ConstantsInvestorGetResponse> {
    return this.http.get<ConstantsInvestorGetResponse>(`${environment.endpointApiTwo}/v2/constants/investor`, {
      headers: { 'Content-Type': 'application/json' },
    });
  }

  fetchActiveInvestors(payload: ActiveInvestorsFetchRequest): Observable<ActiveInvestorsFetchResponse> {
    const { id } = payload;
    return this.http.get<ActiveInvestorsFetchResponse>(
      `${environment.endpointApiOne}/v1/content/activeInvestors/${id}`,
    );
  }
}
